/* Model */
class PaymentMethodModel extends App.Models.BaseModel {
  modelUrl = 'PaymentMethod';
}

App.Models.PaymentMethod = PaymentMethodModel;

/* Collection */
class PaymentMethodCollection extends App.Collections.BaseCollection {
  url = 'PaymentMethod';
  model = App.Models.PaymentMethod;
}

App.Collections.PaymentMethods = PaymentMethodCollection;

/* Router */
class PaymentMethodRouter extends App.Routers.BaseRouter {
  constructor() {
      const entityName = 'PaymentMethod';
      const model = App.Models.PaymentMethod;
      const collectionClass = App.Collections.PaymentMethods;

      super(entityName, model, collectionClass);
  }
}

App.Routers.PaymentMethod = PaymentMethodRouter;